import React, { Component } from 'react';
import * as pt from 'prop-types';
import xtend from 'xtend';
import fileStream from 'filereader-stream';
import moment from 'moment';
import _ from 'underscore';
import * as CSV from 'csv-string'

import parse from '../util/parse-csv';
import Loader from '../../common/components/notifications/Loader';
import ImporterApiDelegate from '../hoc/ImporterApiDelegate';

// import ImporterContainer from './ImporterContainer';
import ImporterContainer from './Importer.legacy';

// Category already exists
// @FIXME This should be an integer coded error from the backend
// or a global on the frontend somehow
const EXISTS_MSG = "Category already exists";

const defaultImporterState = {
    csvData: [],
    events: [],
    importThese: [],

    // map from csv row index to entity id
    encoderMap: {},
    categoryMap: {},
    locationMap: {},

    errors: [],

    dateFilter: {
        start: null,
        end: null
    },

    batchPrivacy: false,
    batchToggle: true,

    categoriesCreated: {
        error: false,
        categories: []
    }
};

/**
 *
 * @param {csv Data line} line
 * @param {string[]} header
 */
const dataObjFromLine = (line, header) => {
    const valArray = CSV.parse(line)[0]
    const obj = {}
    obj.assigned = true
    header.forEach((heading, i) => {
        obj[heading] = valArray[i]
    })
    return obj
}

class ImporterController extends Component {
    constructor (props) {
        super(props);
        this.state = xtend(
            {},
            defaultImporterState,
            this.props.store()
        );

        this.handleBatchToggleChange = this.handleBatchToggleChange.bind(this);
        this.handleAssign = this.handleAssign.bind(this);
        this.onSubmitCsv = this.onSubmitCsv.bind(this);
        this.getEncoderIdByName = this.getEncoderIdByName.bind(this);
        this.getLocationIdByName = this.getLocationIdByName.bind(this);
        this.getCategoryIdByName = this.getCategoryIdByName.bind(this);
        this.createEvents = this.createEvents.bind(this);
        this.handleEncoderAssign = this.handleEncoderAssign.bind(this);
        this.handleRangeChanged = this.handleRangeChanged.bind(this);
        this.handleCategoryAssign = this.handleCategoryAssign.bind(this);
        this.handleLocationAssign = this.handleLocationAssign.bind(this);
        this.handleEstRuntimeChange = this.handleEstRuntimeChange.bind(this);
        this.handleBreakOverrideChange = this.handleBreakOverrideChange.bind(this);
        this.handleBreakOnStartChange = this.handleBreakOnStartChange.bind(this);
        this.handleBatchCategoryAssignment = this.handleBatchCategoryAssignment.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleBatchPrivacyChange = this.handleBatchPrivacyChange.bind(this);
        // this.mergeStateData = this.mergeStateData.bind(this)
        this.getCsvDataFromFile = this.getCsvDataFromFile.bind(this)
    }

    componentWillMount () {
        var self = this;
        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });

        this.props.actions.get();
    }

    componentWillUnmount () {
        this.removeListener();
    }

    shouldComponentUpdate (nextProps, nextState) {
        return this.state !== nextState;
    }

    handleAssign (index, ev, val) {
        const cloneImportThese = [...this.state.importThese]
        const cloneCsvData = [...this.state.csvData]
        cloneImportThese[index] = val
        cloneCsvData[index].assigned = val
        this.setState({
            importThese: cloneImportThese,
            csvData: cloneCsvData
        });
    }

    onSubmitCsv (files) {
        // merge these new files into csvData
        for (let i = 0; i < files.length; i++) {
            this.getCsvDataFromFile(files[i])
        }
    }

    getCsvDataFromFile(file) {
       const reader = new FileReader()
       reader.onload = event => {
        let dataClone = [...this.state.csvData]
           const allLines = event.target.result.split(/\r\n|\n/) // https://stackoverflow.com/questions/23331546/how-to-use-javascript-to-read-local-text-file-and-read-line-by-line
           let header = ''
           allLines.forEach((line, i) => {
               // skip header
               if (i === 0 && line.length) {
                   header = CSV.parse(line)[0]
               } else {
                   if (line.length) {
                        dataClone.push(dataObjFromLine(line, header))
                   }
               }
           })
            // remove duplicates
            const keys = {}
            dataClone = dataClone.filter(data=> {
                const key = data.customID ? data.customID : data.title + data.startDateTime
                if (keys[key]) {
                    // if this key is already taken remove this item from the list of events
                    return false
                } else {
                    // mark this key as taken and keep this item
                    keys[key] = true
                    return true
                }
            })
            // check if any categories need to be added to the list
            const categoryMapClone = Object.assign({}, this.state.categoryMap)
            const encoderMapClone = Object.assign({}, this.state.encoderMap);

            dataClone.forEach((row, i) => {
                var categoryExists = false
                for (let j = 0; j < this.state.categories.data.length; j++) {
                    if (this.state.categories.data[j].categoryName === row.category) {
                        categoryExists = true
                        break
                    }
                }
                if (!categoryExists) {
                    // check that it hasn't already been added to the categoryMap
                    var alreadyAdded = false
                    Object.keys(this.state.categoryMap).forEach(key => {
                        if (this.state.categoryMap[key] === row.category) {
                            alreadyAdded = true
                        }
                    })
                    if (!alreadyAdded) {
                        categoryMapClone[i] = row.category
                    }
                }

                if(!row.estRuntime) row.estRuntime = "01:00"

                if (row.encoder && !encoderMapClone[i]) {
                    encoderMapClone[i] = row.encoder
                }
            })

            this.setState({csvData: dataClone, importThese: dataClone, categoryMap: categoryMapClone, encoderMap: encoderMapClone})
       }
       reader.readAsText(file)
    }

    getEncoderIdByName (csvIndex) {
        var id, assigned = this.state.encoderMap[csvIndex];
        for (var i = 0; i < this.state.encoders.data.length; i++) {
            if (this.state.encoders.data[i].simpleName == assigned) {
                id = this.state.encoders.data[i].encoderID;
                break;
            }
        }
        return id;
    }

    getLocationIdByName (locationName) {
        var id = ''
        for (var i = 0; i < this.state.locations.data.length; i++) {
            if (this.state.locations.data[i].locationName == locationName) {
                id = this.state.locations.data[i].locationID;
                break;
            }
        }
        return id;
    }

    getCategoryIdByName (csvIndex) {
        var id = false;
        var assigned = this.state.categoryMap[csvIndex];
        var categories = this.state.categories.data;

        for (var i = 0; i < categories.length; i++) {
            if (categories[i].categoryName == assigned) {
                id = categories[i].categoryID;
                break;
            }
        }

        // Ensure it's a Base10
        return (id) ? parseInt(id, 10) : false
    }

    createEvents () {
        var self = this;

        var categoriesToAdd = [];

        var preflightUpdates = self.state.csvData;
        this.state.csvData.forEach(function (row, i) {
            if (self.state.importThese[i] && preflightUpdates[i].createStatus !== 'success') {
                preflightUpdates[i].createStatus = 'creating';
            }
        });

        self.setState(function (state, props) {
            return { csvData: preflightUpdates };
        });

        var actions = self.props.actions;

        var events = this.state.csvData.map(function (row, i) {
            var updates = {};
            if (self.state.categoryMap[i] || (row.category && row.category.length)) {
                var categoryID = self.getCategoryIdByName(i);
                updates.categories = [(categoryID) ? categoryID : row.category];
                if (
                    !!_.find(
                        self.state.categories.data,
                        { categoryName: row.category }
                    ) === false &&
                    categoriesToAdd.indexOf(row.category) < 0
                ) {
                    // Only create unique categories
                    categoriesToAdd.push(row.category);
                }
            }

            if (self.state.encoderMap[i]) {
                updates.encoderID = self.getEncoderIdByName(i);
            }

            if (self.state.locationMap[i]) {
                updates.locationID = self.getLocationIdByName(self.state.locationMap[i]);
            }
            if (!updates.locationID && row.location) {
                updates.locationID = self.getLocationIdByName(row.location)
            }
            if (!updates.hasOwnProperty('private')) updates.private = row.private;
            return xtend(row, updates);
        }, this);

        function create (index = 0) {
            if (self.state.importThese[index] && self.state.csvData[index].createStatus !== 'success') {
                var event = events[index];

                function getCategoryId (categories, name) {
                    var id;

                    for (var i = 0; i < categories.length; i++) {
                        if (categories[i].categoryName == name) {
                            id = categories[i].categoryID;
                            break;
                        }
                    }
                    return id ? parseInt(id, 10) : false;
                }

                var hasCat
                try {
                    hasCat = (!!event.category !== false &&
                        typeof event.category !== "number")
                } catch (err) {
                    // ok
                }

                if (hasCat) {
                    // Replace Category's Name with newly created Category ID
                    var categoryID = getCategoryId(
                        self.state.categoriesCreated.categories,
                        event.category
                    );
                    if (!categoryID) {
                        categoryID = getCategoryId(
                            self.state.categories.data,
                            event.category
                        )
                    }
                    if (categoryID) event.categories = [categoryID];
                }


                if (event.estRuntime){
                    event.estRuntime = moment.duration(event.estRuntime).asMinutes()
                }

                if (event.breakOverride === "TRUE") event.breakOverride = true;
                if (event.breakOverride === "FALSE") event.breakOverride = false;

                if (event.liveToBreak === "TRUE") event.liveToBreak = true;
                if (event.liveToBreak === "FALSE") event.liveToBreak = false;

                console.log("EVENT", event)

                actions.createEvent(event, function onResp (err, data) {
                    var stateUpdate = self.state.csvData;
                    var didCreate = false;
                    if (!err) {
                        didCreate = true;
                        stateUpdate[index] = xtend(data.data, {
                            createStatus: 'success'
                        });
                    } else if (err) {
                        stateUpdate[index] = xtend(self.state.importThese[index], {
                            createStatus: 'fail',
                            errorMessages: err.message
                        });
                    }

                    self.setState({ csvData: stateUpdate });

                    if (events[index + 1]) create(index + 1);
                });
            } else if (events[index + 1]) {
                create(index + 1);
            }
        }

        if (events.length) {
            if (categoriesToAdd.length) {
                function createCategory (index) {
                    if (!index) index = 0;

                    actions.createCategory({
                        clientID: self.props.clientID,
                        categoryName: categoriesToAdd[index]
                    }, function (err, resp) {

                        if (err && (
                            err.message != EXISTS_MSG ||
                            err.message[0] != EXISTS_MSG
                        )) {
                            self.setState({
                                categoriesCreated: xtend(
                                    self.state.categoriesCreated,
                                    { error: true }
                                )
                            })
                        } else if (!err) {
                            let createdCategory = resp.data

                            var addedCategories =
                                self.state.categoriesCreated.categories.concat({
                                    categoryName: categoriesToAdd[index],
                                    categoryID: createdCategory.categoryID
                                });

                            // @NOTE the Categories array will only have one
                            // category associated with it for the time-being,
                            // we therefore don't need to concat onto an existing
                            // array of pending categories like some kind of
                            // sane person would
                            // var events = self.state.csvData
                            //
                            // var updatedEvent =
                            //     self.state.csvData[
                            //         categoriesToAdd[index].csvIndex
                            //     ]
                            //
                            // updatedEvent.categories = [categoriesToAdd[index]]
                            //
                            // events[
                            //     categoriesToAdd[index].csvIndex
                            // ] = updatedEvent

                            self.setState({
                                // csvData: events,
                                categoriesCreated: xtend(
                                    self.state.categoriesCreated,
                                    {
                                        categories: addedCategories
                                    }
                                )
                            })
                        }

                        if (categoriesToAdd[index + 1]) {
                            createCategory(index + 1)
                        } else {
                            create()
                        }
                    })
                }
                createCategory();
            } else {
                create();
            }
        }
    }

    handleEncoderAssign (csvIndex, encoderName) {
        var map = {};
        map[csvIndex] = encoderName;
        this.setState({
            encoderMap: xtend(this.state.encoderMap, map)
        });
    }

    handleCategoryAssign (eventCategoryIndex, categoryName) {
        const csvData = [...this.state.csvData]
        const {categoryMap} = this.state
        csvData[eventCategoryIndex].category = categoryName
        categoryMap[eventCategoryIndex] = categoryName
        this.setState({
            csvData, categoryMap
        });
    }

    handleEstRuntimeChange (csvIndex, estRuntime) {
        const csvData = [...this.state.csvData]

        csvData[csvIndex].estRuntime = estRuntime;
        this.setState({
            csvData,
        });
    }

    handleBreakOverrideChange (csvIndex, breakOverride) {
        const csvData = [...this.state.csvData]

        csvData[csvIndex].breakOverride = breakOverride;
        this.setState({
            csvData,
        });
    }

    handleBreakOnStartChange (csvIndex, liveToBreak) {
        const csvData = [...this.state.csvData]

        csvData[csvIndex].liveToBreak = liveToBreak;
        this.setState({
            csvData,
        });
    }

    handleLocationAssign (csvIndex, locationName) {
        var map = {};
        map[csvIndex] = locationName;
        this.setState({
            locationMap: xtend(this.state.locationMap, map)
        });
    }

    handleBatchCategoryAssignment (category, event) {
        event && event.preventDefault();
        const csvData = [...this.state.csvData]
        if (category && this.state.csvData.length) {
            var map = {};
            this.state.csvData.forEach(function (event, index) {
                map[index] = category;
                csvData[index].category = category
            });
            this.setState({ csvData, categoryMap: map });
        }
    }

    handleReset () {
        this.setState(xtend(defaultImporterState, this.props.store()));
    }

    handleBatchToggleChange () {
        var nextValue = !this.state.batchToggle;
        var updates = this.state.importThese;
        var csvUpdates = [...this.state.csvData]

        Object.keys(updates).map(function (el, index) {
            updates[index] = nextValue;
            csvUpdates[index].assigned = nextValue;
        }, this);

        this.setState({
            importThese: updates,
            csvData: csvUpdates,
            batchToggle: nextValue
        });
    }

    handleBatchPrivacyChange (ev) {
        var nextValue = !this.state.batchPrivacy;
        const newCsvData = [...this.state.csvData].map(function (ev, i) {
            return {
                ...ev,
                private: nextValue
            }
        });
        this.setState({
            csvData: newCsvData,
            batchPrivacy: nextValue
        });
    }

    handleRangeChanged (updates) {
        this.setState({
            dateFilter: updates
        });
    }

    render () {
        if (
            this.state.encoders.isResolving ||
            this.state.locations.isResolving ||
            this.state.categories.isResolving
        ) return <Loader message="Loading"/>;

        return <ImporterContainer
            batchToggle={this.state.batchToggle}
            handleBatchToggleChange={this.handleBatchToggleChange}

            batchPrivacy={this.state.batchPrivacy}
            handleBatchPrivacyChange={this.handleBatchPrivacyChange}

            dateFilter={this.state.dateFilter}
            handleRangeChanged={this.handleRangeChanged}

            csvData={this.state.csvData}
            events={this.state.events}

            categoryMap={this.state.categoryMap}
            encoderMap={this.state.encoderMap}
            locationMap={this.state.locationMap}
            encoders={this.state.encoders}

            categories={this.state.categories}
            locations={this.state.locations}

            errors={this.state.errors}

            onReset={this.handleReset}
            onSubmitCsv={this.onSubmitCsv}
            onAssign={this.handleAssign}
            onEncoderAssign={this.handleEncoderAssign}
            onCategoryAssign={this.handleCategoryAssign}
            onLocationAssign={this.handleLocationAssign}
            onCreateEvents={this.createEvents}
            onBatchCategoryAssignment={this.handleBatchCategoryAssignment}
            onEstRuntimeChange={this.handleEstRuntimeChange}
            onBreakOverrideChange={this.handleBreakOverrideChange}
            onBreakOnStartChange={this.handleBreakOnStartChange}

            categoriesCreated={this.state.categoriesCreated}
        />;
    }
}

ImporterController.propTypes = {
    store: pt.func.isRequired,
    actions: pt.shape({
        get: pt.func.isRequired,
        createEvent: pt.func.isRequired
    }).isRequired,
    mode: pt.string,
    clientID: pt.string.isRequired
};

var ImporterControllerWithApiDelegate = ImporterApiDelegate(
    ImporterController
);

export default ImporterControllerWithApiDelegate;
// export default ImporterController;
// export default ImporterController;
